import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { parsedUserAgent } from "@100mslive/react-sdk";
import { Cross, SearchIcon } from "../../../icons";
import { ToastManager } from "../../Toast/ToastManager";
import { COMMUNITY_SERVICES } from "../../../services";

const EventHeaderSearch = () => {
  const [searchData, setSearchData] = useState("");
  const [searchFilter, setSearchFilter] = useState({
    search: "",
    type: "",
    open: false,
  });
  const [loading, setLoading] = useState(true);
  const searchRef = useRef(null);
  const [placeHolder, setPlaceHolder] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const isMac = parsedUserAgent.getOS().name.toLowerCase() === "mac os";
    setPlaceHolder(
      `Search for any company, crypto and event ${isMac ? "(⌘K)" : "(Ctrl+K)"}`
    );
    const handleKeyDown = e => {
      if (
        (isMac && e.metaKey && e.key === "k") ||
        (!isMac && e.ctrlKey && e.key === "k")
      ) {
        e.preventDefault();
        searchRef.current?.focus();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (searchFilter?.open) {
      setLoading(true);
      COMMUNITY_SERVICES.search({
        search: searchFilter?.search,
        type: searchFilter?.type,
      })
        .then(data => {
          if (data.code === 200) {
            setSearchData(searchFilter?.open ? data.data : "");
          }
        })
        .catch(err => {
          ToastManager.addToast({ title: err.message });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setSearchData("");
      if (searchFilter?.search) {
        setSearchFilter(old => ({
          ...old,
          search: "",
        }));
      }
    }
  }, [searchFilter]);

  const onClearSearch = () => {
    setSearchFilter(old => ({
      ...old,
      open: false,
    }));
  };
  const onType = text => {
    setSearchFilter(old => ({
      ...old,
      type: text,
    }));
    setSearchData("");
  };
  const filterOpen = () => {
    if (!searchFilter?.open) {
      setSearchFilter(old => ({
        ...old,
        open: true,
      }));
    }
  };

  const sendQuery = () => {
    if (searchFilter?.search?.trim()) {
      navigate("/ai/chat?q_ai=" + searchFilter?.search?.trim());
      onClearSearch();
    }
  };

  return (
    <React.Fragment>
      <div className="events6ix-layout-header-search">
        {searchFilter?.open && (
          <div
            className="events6ix-layout-header-search-backdrop"
            onClick={onClearSearch}
          ></div>
        )}

        <label
          htmlFor="header-company-search-input"
          className="events6ix-layout-header-search-icon"
        >
          <SearchIcon />
        </label>
        <input
          id="header-company-search-input"
          className="events6ix-layout-header-search-input active"
          ref={searchRef}
          type="search"
          value={searchFilter?.search}
          onChange={e => {
            setSearchFilter(old => ({
              ...old,
              search: e.target.value,
            }));
          }}
          placeholder={placeHolder}
          onKeyDown={e => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              sendQuery();
            }
          }}
          onFocus={filterOpen}
        />
        {searchFilter?.open && (
          <>
            <button
              onClick={onClearSearch}
              className="events6ix-layout-header-search-btn"
              type="button"
            >
              <Cross />
            </button>

            <div className="events6ix-layout-header-search-result">
              <div className="events6ix-layout-header-search-result-header">
                <div
                  className={`events6ix-layout-header-search-result-header-btn ${
                    !searchFilter?.type ? "active" : ""
                  }`}
                  onClick={() => onType("")}
                >
                  All
                </div>
                <div
                  className={`events6ix-layout-header-search-result-header-btn ${
                    searchFilter?.type === "stocks" ? "active" : ""
                  }`}
                  onClick={() => onType("stocks")}
                >
                  Stocks
                </div>
                <div
                  className={`events6ix-layout-header-search-result-header-btn ${
                    searchFilter?.type === "crypto" ? "active" : ""
                  }`}
                  onClick={() => onType("crypto")}
                >
                  Crypto
                </div>
                <div
                  className={`events6ix-layout-header-search-result-header-btn ${
                    searchFilter?.type === "events" ? "active" : ""
                  }`}
                  onClick={() => onType("events")}
                >
                  Events
                </div>
                <div
                  className={`events6ix-layout-header-search-result-header-btn ${
                    searchFilter?.type === "speakers" ? "active" : ""
                  }`}
                  onClick={() => onType("speakers")}
                >
                  Speakers
                </div>
              </div>
              <div className="events6ix-layout-header-search-result-body">
                {searchData?.list?.length > 0 ||
                searchData?.events?.length > 0 ||
                searchData?.speakers?.length > 0 ? (
                  <>
                    {searchData?.list.map((item, index) => (
                      <Link
                        key={index}
                        to={`/company/${item?.orgSlug}`}
                        className="events6ix-layout-header-search-result-body-item"
                        onClick={onClearSearch}
                      >
                        {item?.orgStocks?.[0]?.symbol ? (
                          <>
                            <span className={item?._id ? "text-primary" : ""}>
                              {item?.orgStocks?.[0]?.symbol}
                            </span>{" "}
                            -{" "}
                          </>
                        ) : item?.orgCoin?.symbol ? (
                          <>
                            <span className={item?._id ? "text-primary" : ""}>
                              {item?.orgCoin?.symbol}
                            </span>{" "}
                            -{" "}
                          </>
                        ) : null}
                        {item?.orgName}
                      </Link>
                    ))}

                    {searchData?.events?.map((item, index) => (
                      <Link
                        key={index}
                        to={item?.eventMeetingLink}
                        className="events6ix-layout-header-search-result-body-item"
                        onClick={onClearSearch}
                      >
                        {item?.eventName}
                      </Link>
                    ))}
                    {searchData?.speakers?.map((item, index) => (
                      <Link
                        key={index}
                        to={`/u/${item?.username}`}
                        className="events6ix-layout-header-search-result-body-item"
                        onClick={onClearSearch}
                      >
                        {item?.name}
                      </Link>
                    ))}
                  </>
                ) : (
                  <div className="events6ix-layout-header-search-result-body-noItem">
                    {loading ? (
                      <CircularProgress />
                    ) : (
                      <>No results match your criteria</>
                    )}
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default EventHeaderSearch;
